(function () {
  function makeXhr(method, url, data, domain) {
    var xhttp = new XMLHttpRequest();
    xhttp.open(method, url, true);
    xhttp.setRequestHeader('Content-type', 'application/json');
    xhttp.setRequestHeader('x-shopify-shop-domain', domain);
    xhttp.send(data ? JSON.stringify(data) : null);
  }

  function init(block) {
    var nmId         = block.dataset.nmBlock;
    var scriptUrl    = block.dataset.nmScriptUrl   || '';
    var productTitle = block.dataset.nmProduct     || '';
    var productId    = block.dataset.nmProductId   || '';
    var productUrl   = block.dataset.nmUrl         || '';
    var phonePrefix  = block.dataset.nmPrefix      || '+91';
    var popupBtnText = block.dataset.nmPopupBtn    || 'Notify Me';

    var overlay    = document.getElementById('nm-overlay-'   + nmId);
    var formWrap   = document.getElementById('nm-form-wrap-' + nmId);
    var form       = document.getElementById('nm-form-'      + nmId);
    var nameInput  = document.getElementById('nm-name-'      + nmId);
    var emailInput = document.getElementById('nm-email-'     + nmId);
    var emailErr   = document.getElementById('nm-email-err-' + nmId);
    var phoneInput = document.getElementById('nm-phone-'     + nmId);
    var submitBtn  = document.getElementById('nm-submit-'    + nmId);
    var errEl      = document.getElementById('nm-err-'       + nmId);
    var tyEl       = document.getElementById('nm-ty-'        + nmId);
    var notifNum   = document.getElementById('nm-notif-num-' + nmId);
    var editBtn    = document.getElementById('nm-edit-btn-'  + nmId);

    function open() {
      overlay && overlay.classList.add('nm-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      overlay && overlay.classList.remove('nm-open');
      document.body.style.overflow = '';
    }

    function showThanks() {
      formWrap.classList.add('nm-hidden');
      tyEl.classList.add('nm-show');
      submitBtn.disabled = false;
      submitBtn.textContent = popupBtnText;
    }

    function resetSheet() {
      tyEl && tyEl.classList.remove('nm-show');
      formWrap && formWrap.classList.remove('nm-hidden');
      form && form.reset();
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = popupBtnText;
      }
      errEl && errEl.classList.remove('nm-show');
      emailErr && emailErr.classList.remove('nm-show');
    }

    window['nmOosOpen'  + nmId] = open;
    window['nmOosClose' + nmId] = close;

    overlay && overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.classList.contains('nm-open')) close();
    });

    editBtn && editBtn.addEventListener('click', function () {
      tyEl.classList.remove('nm-show');
      formWrap.classList.remove('nm-hidden');
      phoneInput && phoneInput.focus();
    });

    form && form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name  = nameInput  ? nameInput.value.trim()  : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var phone = phoneInput ? phoneInput.value.trim() : '';

      var emailOk = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!emailOk) {
        emailErr && emailErr.classList.add('nm-show');
        emailInput && emailInput.focus();
        return;
      }
      emailErr && emailErr.classList.remove('nm-show');

      if (phone && !/^\d{10}$/.test(phone)) {
        errEl && errEl.classList.add('nm-show');
        phoneInput && phoneInput.focus();
        return;
      }
      errEl && errEl.classList.remove('nm-show');

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      var displayPhone = phone ? (phonePrefix + ' ' + phone) : '';
      if (notifNum) notifNum.textContent = displayPhone || email;

      if (!scriptUrl) { showThanks(); return; }

      var now = new Date();
      var formattedTimestamp = now.toLocaleDateString('en-GB') + ' ' + now.toLocaleTimeString('en-IN', { hour12: false });

      var params = new URLSearchParams({
        timestamp: formattedTimestamp,
        name: name || '',
        email: email,
        phone: phone,
        product: productTitle,
        url: productUrl
      });

      var variantId = (document.getElementsByName('id')[0] || {}).value || '';
      makeXhr('POST', 'https://iy08ni8pq5.execute-api.ap-south-1.amazonaws.com/api/notify/api', {
        phone: phonePrefix + phone,
        variant_id: variantId,
        product_id: productId,
        product_title: productTitle,
        variant_url: window.location.href
      }, window.location.hostname);

      fetch(scriptUrl + '?' + params, { method: 'GET', mode: 'no-cors' })
        .then(showThanks).catch(showThanks);
    });

    overlay && overlay.addEventListener('transitionend', function () {
      if (!overlay.classList.contains('nm-open')) setTimeout(resetSheet, 300);
    });
  }

  document.querySelectorAll('[data-nm-block]').forEach(init);

  /* Swap notify/buy panels on variant change — single global listener */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    var isOos = !v.available;
    document.querySelectorAll('.nm-notify-panel').forEach(function (p) {
      p.classList.toggle('nm-panel-hidden', !isOos);
    });
    document.querySelectorAll('.nm-buy-panel').forEach(function (p) {
      p.classList.toggle('nm-panel-hidden', isOos);
    });
    if (!isOos) {
      document.querySelectorAll('[data-nm-overlay]').forEach(function (o) {
        o.classList.remove('nm-open');
      });
      document.body.style.overflow = '';
    }
  });
})();
